import { Alert } from "@mantine/core";
import { IAzureBlobFile } from "@schemas/azureSchema";
import React, { useState } from "react";
import { ConfirmDialog, DeleteButton, MCLoader, VSpace } from "../../../../components";
import { setShowSuccessMessageThunk } from "../../../../global/globalSlice";
import { useAppDispatch, useAppSelector } from "../../../../hooks";
import { ToastMessagesEnums } from "@mcapps/shared/sharedConstants";
import {
  useDeleteFileInAzureBlobStorageMutation,
  useGetFilesFromAzureBlobStorageQuery,
  useUploadFileToAzureBlobStorageMutation,
} from "../../../azureBlobStorageRTK";
import { selectHttpSingleReportBoard } from "../reportSelectors";

const ReportDocxImageContainer: React.FC<{ docxImageTag: string; title: string }> = ({ docxImageTag, title }) => {
  const [imageRefreshKey, setImageRefreshKey] = useState(Date.now());
  const report = useAppSelector(selectHttpSingleReportBoard);
  const project = useAppSelector((state) => state.adminReducer.project);
  const path = `${project?._id}/report/${report?._id}/images/${docxImageTag}`;

  const {
    data: files,
    isLoading: loadingFiles,
    isError: errorFetchingFiles,
  } = useGetFilesFromAzureBlobStorageQuery({ projectId: project?._id, path });

  let image: IAzureBlobFile | undefined;
  if (files?.length > 0) {
    image = files[0];
  }

  const pathWithRefreshKey = image ? `api/image/${image?.blobName}?key=${imageRefreshKey}` : "";

  const [uploadFile, { isLoading: fileIsUploading }] = useUploadFileToAzureBlobStorageMutation();
  const [deleteFile, { isLoading: fileIsDeleting }] = useDeleteFileInAzureBlobStorageMutation();

  const isLoading = loadingFiles || fileIsUploading || fileIsDeleting;

  const dispatch = useAppDispatch();

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    await uploadFile({ projectId: project?._id, file, path });
    setImageRefreshKey(Date.now());
    dispatch(setShowSuccessMessageThunk(ToastMessagesEnums.FILE_UPLOADED));
  };

  const deleteImage = async () => {
    await deleteFile({ projectId: project._id, fileId: image?.blobName });
    setImageRefreshKey(Date.now());
    dispatch(setShowSuccessMessageThunk(ToastMessagesEnums.FILE_DELETED));
  };

  return (
    <div className="d-flex">
      {project == null && <Alert color="info">Filopplasting er ikke tilgjengelig i admin-modus</Alert>}
      {isLoading === false ? (
        <div>
          {files?.length === 0 ? (
            <div>
              <h5 className="p-0 m-0">{title}</h5>
              <p>Last opp et bilde</p>
              <input type="file" accept="image/*" onChange={handleFileChange} />
            </div>
          ) : (
            <div className="flex-column">
              <div className="d-flex">
                <h5 className="p-0 m-0 mt-2">{title}</h5>
                <div className="flex-grow-1" />
                <ConfirmDialog
                  confirmCb={deleteImage}
                  message="Vil du slette bildet? Dette kan ikke angres!"
                  title="Slette bildet?"
                >
                  <DeleteButton onClick={deleteImage} outline />
                </ConfirmDialog>
              </div>
              <VSpace />
              <img style={{ height: "500px" }} alt="" src={pathWithRefreshKey} />
            </div>
          )}
        </div>
      ) : (
        <MCLoader loading />
      )}
    </div>
  );
};
export default ReportDocxImageContainer;
